<template lang="pug">
  SubmitButton(
    :loading="loading || loading2"
    icon="fa fa-file-excel"
    :text="$t('ui.' + btnTxt)"
    type="button"
    @click="exportFile()"
    variant="info"
    size="sm"
  )
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import clearOutstandingVue from '../components/member/clearOutstanding.vue';

export default {
  components: {
    SubmitButton
  },
  props: {
    loading2: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "0"
    },
    mode: {
      type: String,
      default: ""
    },
    date: {
      type: Object,
      default: ""
    },
    tbl: {
      type: String,
      default: ""
    },
    tbl2: {
      type: String,
      default: ""
    },
    dttbl: {
      type: Array,
      default() {
        return []
      }
    },
    btnTxt: {
      type: String,
      default: "export_excel"
    }
  },
  data(){
    return{
      loading: false,
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  methods: {
    exportFile() {
      if(this.type == '1') {
        var mode = this.mode;
        switch(mode) {
          case 'BonusLog':
            this.tableToExcelBonusLog()
            break;
          case 'OneTimeDepositor':
            this.tableToExcelOneTimeDepositor()
            break;
          case 'CurrentMonthNonDepositor':
            this.tableToExcelCurrentMonthNonDepositor()
            break;
          case 'CurrentMonthNoLogin':
            this.tableToExcelCurrentMonthNoLogin()
            break;
          case 'DepositedMember':
            this.tableToExcelDepositedMember()
            break;
          case 'RegisteredMember':
            this.tableToExcelRegisteredMember()
            break;
          case 'FirstDeposit':
            this.tableToExcelFirstDeposit()
            break;
          case 'RebateListMember':
            this.tableToExcelRebateListMember();
            break;
          case 'tableToExcelCustomMember':
            this.tableToExcelCustomMember();
            break;
          case 'LoginLog':
            this.tableToExcelLoginLog();
            break;
          case 'AdjustmentLog':
            this.tableToExcelAdjustmentLog()
            break;
          case 'GameNameExcludeLog':
            this.tableToExcelGameNameExcludeLog()
            break;
          case 'DailyLedgerOperator':
            this.tableToExcelDailyLedgerOperator()
            break;
          case 'DailyLedgerMember':
            this.tableToExcelDailyLedgerMember()
            break;
          case 'DailyPnlOperator':
            this.tabletoExcelDailyPnlOperator()
            break;
          case 'CPICustomList':
            this.tableToExcelCpiCustomList();
            break;
          case 'FreeSpinLog':
            this.tableToExcelFreeSpinLog();
            break;
          case 'FreeBalanceLog':
            this.tableToExcelAdjustFreeBalanceLog();
            break;
        }
      } else {
        // this.tableToExcel()
        this.tableToExcelNew2()
      }
    },
    tableToExcelCustomMember() {
      var tableID = this.tbl;
      // Get the table element
      const table = document.getElementById(tableID);

      // Create a worksheet from the table
      const worksheet = XLSX.utils.table_to_sheet(table, {raw: true});

      // Ensure the ID column is treated as text to preserve leading zeros
      for (let cell in worksheet) {
          if (worksheet.hasOwnProperty(cell) && cell.startsWith('A') && !isNaN(cell.substring(1))) {
              worksheet[cell].z = '@'; // Set the format to text
              worksheet[cell].t = 's'; // Specify cell as text
          }
      }

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Export the workbook to an Excel file
      XLSX.writeFile(workbook, "CustomMemberList.xlsx");
    },
    tableToExcel(){
      var table = this.tbl;
      this.loading = true;
      if (!table.nodeType) table = document.getElementById(table)
      var worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD")
      var iHtml = table.innerHTML.toString().replaceAll('href="javascript:void(0);"', '').replaceAll('target="_self"', '');
      var ctx = {worksheet: worksheetTitle || 'Worksheet', table: iHtml}
      // window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      var link = document.createElement("a")
      link.download = this.mode + "-" + this.$store.getters.accountId.toUpperCase() + "-" +  worksheetTitle +  ".xls"
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
      this.loading = false;
    },
    // tableToExcelNew2() {
    //   this.loading = true;

    //   // Get the table element
    //   var table = this.tbl;
    //   if (!table.nodeType) table = document.getElementById(table);

    //   // Convert table to a worksheet
    //   const ws = XLSX.utils.table_to_sheet(table);

    //   // Set column widths based on table content
    //   const tableHeaders = table.querySelectorAll('th');
    //   const colWidths = Array.from(tableHeaders).map(th => ({
    //     wch: th.innerText.length + 5 // Adjust column width dynamically (e.g., text length + padding)
    //   }));
    //   ws['!cols'] = colWidths;

    //   // Format date-time cells explicitly
    //   const dataRows = table.querySelectorAll('tr:not(.footer)');
    //   Array.from(dataRows).forEach((row, rowIndex) => {
    //     const cells = row.querySelectorAll('td');
    //     Array.from(cells).forEach((cell, colIndex) => {
    //       const cellValue = cell.innerText;

    //       //If the value looks like a date-time, format it explicitly
    //       if (/^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(cellValue)) {
    //         const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
    //         ws[excelCellRef] = { t: 's', v: cellValue }; // Treat as text to preserve formatting
    //       } 
    //       else {
    //         const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
    //         ws[excelCellRef] = { t: 's', v: cellValue };
    //       }
    //     });
    //   });

    //   // Create a workbook and append the worksheet
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

    //   // Set the filename
    //   const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD");
    //   const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

    //   // Export to Excel file
    //   XLSX.writeFile(workbook, filename);

    //   this.loading = false;
    // },
    tableToExcelNew2() {
      // Get the table element
      let table = this.tbl;
      if (!table.nodeType) table = document.getElementById(table);
      if (!table) return;

      // Convert table to a worksheet
      const ws = XLSX.utils.table_to_sheet(table);

      // Set column widths based on table header content
      const tableHeaders = table.querySelectorAll('th');
      const colWidths = Array.from(tableHeaders).map(th => ({
        wch: th.innerText.length + 5 // Adjust width dynamically
      }));
      ws['!cols'] = colWidths;

      // Format data cells correctly (text/date/number)
      const dataRows = table.querySelectorAll('tr:not(.footer)');
      Array.from(dataRows).forEach((row, rowIndex) => {
        const cells = row.querySelectorAll('td');
        Array.from(cells).forEach((cell, colIndex) => {
          const cellValue = cell.innerText.trim();
          const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });

          // Date-time detection (e.g., 2024-05-01, 12:34:56)
          if (/^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(cellValue)) {
            ws[excelCellRef] = { t: 's', v: cellValue }; // Keep as text
            return;
          }

          // Number detection (handles "1234" or "1,234.56")
          const numericValue = cellValue.replace(/,/g, '');
          if (!isNaN(numericValue) && numericValue !== '') {
            ws[excelCellRef] = { t: 'n', v: parseFloat(numericValue) };
            return;
          }

          // Default: treat as text
          ws[excelCellRef] = { t: 's', v: cellValue };
        });
      });

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

      // Set filename
      const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + 
                            this.$moment(this.date.endDate).format("YYYYMMDD");
      const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

      // Export to Excel file
      XLSX.writeFile(workbook, filename);

      this.loading = false;
    },
    tableToExcelCpiCustomList() {
      // Get the table element
      let table = this.tbl;
      if (!table.nodeType) table = document.getElementById(table);
      if (!table) return;

      // Convert table to a worksheet
      const ws = XLSX.utils.table_to_sheet(table);

      // Set column widths based on table header content
      const tableHeaders = table.querySelectorAll('th');
      const colWidths = Array.from(tableHeaders).map(th => ({
        wch: th.innerText.length + 5 // Adjust width dynamically
      }));
      ws['!cols'] = colWidths;

      // Format data cells correctly (text/date/number)
      const dataRows = table.querySelectorAll('tr:not(.footer)');
      Array.from(dataRows).forEach((row, rowIndex) => {
        const cells = row.querySelectorAll('td');
        Array.from(cells).forEach((cell, colIndex) => {
          const cellValue = cell.innerText.trim();
          const excelCellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });

          // 🔥 FORCE ENTIRE SECOND COLUMN (colIndex = 1) TO TEXT
          if (colIndex === 1) {
            ws[excelCellRef] = { t: 's', v: String(cellValue) };
            return;  // STOP — do NOT run number detection for this column
          }

          // Date-time detection (e.g., 2024-05-01, 12:34:56)
          if (/^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(cellValue)) {
            ws[excelCellRef] = { t: 's', v: cellValue }; // Keep as text
            return;
          }

          // Number detection (handles "1234" or "1,234.56")
          const numericValue = cellValue.replace(/,/g, '');
          if (!isNaN(numericValue) && numericValue !== '') {
            ws[excelCellRef] = { t: 'n', v: parseFloat(numericValue) };
            return;
          }

          // Default: treat as text
          ws[excelCellRef] = { t: 's', v: cellValue };
        });
      });

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

      // Set filename
      const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + 
                            this.$moment(this.date.endDate).format("YYYYMMDD");
      const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

      // Export to Excel file
      XLSX.writeFile(workbook, filename);

      this.loading = false;
    },
    // tabletoExcelDailyPnlOperator() {
    //   this.loading = true;

    //   // Create a new workbook
    //   const workbook = XLSX.utils.book_new();

    //   // Prepare an array to store all rows for the single sheet
    //   let allRows = [];
    //   let colWidths = [];
    //   let merges = [];  // Array to store merge ranges

    //   // Select all tables to export
    //   const tables = [this.tbl, this.tbl2]
    //   // Helper function to detect date-time format (e.g., "2024-04-17, 14:32:55")
    //   const isDateTime = (value) => /^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(value);
      
    //   // Iterate over each table
    //   tables.forEach((table, tableIndex) => {
    //     // Get the table element
    //     if (!table.nodeType) table = document.getElementById(table);
    //     const rows = table.querySelectorAll('tr');
        
    //     // Collect rows from each table
    //     rows.forEach((row, rowIndex) => {
    //       const cells = row.querySelectorAll('td, th');
    //       const rowData = [];
    //       let lastColIndex = 0;

    //       cells.forEach((cell, colIndex) => {
    //         const cellValue = cell.innerText;
    //         // Detects if there is a colspan (if not, default is 1)
    //         const colspan = parseInt(cell.getAttribute('colspan')) || 1;

    //         // Handle date-time explicitly
    //         if (isDateTime(cellValue)) {
    //           // Format as string (keep original format)
    //           cellValue = { t: 's', v: cellValue };
    //         }

    //         // Handle colspan by adding extra cells
    //         // Pushes the cell’s value into the row data, once for each column it spans.
    //         for (let i = 0; i < colspan; i++) {
    //           rowData.push(cellValue);
    //         }

    //         // Dynamically adjust column widths
    //         if (rowIndex === 0 && colIndex >= colWidths.length) {
    //           colWidths.push({ wch: cellValue.length + 5 });
    //         } else if (colWidths[colIndex] && colWidths[colIndex].wch < cellValue.length + 5) {
    //           colWidths[colIndex].wch = cellValue.length + 5; // Update column width
    //         }

    //         // If there is a colspan, add a merge entry
    //         if (colspan > 1) {
    //           merges.push({
    //             s: { r: allRows.length, c: lastColIndex },  // Starting cell for merge
    //             e: { r: allRows.length, c: lastColIndex + colspan - 1 } // Ending cell for merge
    //           });
    //         }

    //         lastColIndex += colspan;
    //       });

    //       allRows.push(rowData);  // Add row data to all rows
    //     });

    //     // Add an empty row between tables
    //     if (tableIndex < tables.length - 1) {
    //       allRows.push(new Array(colWidths.length).fill('')); // Empty row with same number of columns
    //     }

    //     // Handle footer data if exists (with colspan handling)
    //     const footer = table.querySelector('tfoot');
    //     if (footer) {
    //       const footerRows = footer.querySelectorAll('tr');
    //       footerRows.forEach((footerRow, footerRowIndex) => {
    //         const cells = footerRow.querySelectorAll('td');
    //         const footerRowData = [];
    //         let lastColIndex = 0;

    //         cells.forEach((cell) => {
    //           const cellValue = cell.innerText;
    //           const colspan = parseInt(cell.getAttribute('colspan')) || 1;

    //           // Add footer cell data for each colspan
    //           for (let i = 0; i < colspan; i++) {
    //             footerRowData.push(cellValue);
    //           }

    //           // Create a merge entry for footer cells with colspan
    //           if (colspan > 1) {
    //             merges.push({
    //               s: { r: allRows.length, c: lastColIndex },  // Starting cell for merge
    //               e: { r: allRows.length, c: lastColIndex + colspan - 1 }  // Ending cell for merge
    //             });
    //           }

    //           lastColIndex += colspan;
    //         });

    //         allRows.push(footerRowData);  // Add footer row data to all rows
    //       });
    //     }
    //   });

    //   // Convert all rows into a worksheet
    //   const ws = XLSX.utils.aoa_to_sheet(allRows);

    //   // Set column widths
    //   ws['!cols'] = colWidths;

    //   // Add merges to the worksheet if there are any
    //   if (merges.length > 0) {
    //     ws['!merges'] = merges;
    //   }

    //   // Append the worksheet to the workbook
    //   XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

    //   // Set the filename
    //   const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD");
    //   const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

    //   // Export the workbook to an Excel file
    //   XLSX.writeFile(workbook, filename);

    //   this.loading = false;
    // },
    tabletoExcelDailyPnlOperator() { 
      this.loading = true;

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Prepare data structures
      let allRows = [];
      let colWidths = [];
      let merges = []; // Store merged cell ranges

      // Select all tables to export
      const tables = [this.tbl, this.tbl2];

      // Helper functions
      const isDateTime = (value) => /^\d{4}-\d{2}-\d{2}, \d{2}:\d{2}:\d{2}$/.test(value);

      // Iterate over each table
      tables.forEach((table, tableIndex) => {
        if (!table.nodeType) table = document.getElementById(table);
        if (!table) return;

        const rows = table.querySelectorAll('tr');
        
        rows.forEach((row, rowIndex) => {
          const cells = row.querySelectorAll('td, th');
          const rowData = [];
          let lastColIndex = 0;

          cells.forEach((cell, colIndex) => {
            let cellValue = cell.innerText.trim();
            const colspan = parseInt(cell.getAttribute('colspan')) || 1;

            // ✅ Smart cell type detection
            if (isDateTime(cellValue)) {
              // Keep date-time as text
              cellValue = { t: 's', v: cellValue };
            } else {
              // Try to detect numeric values
              const numericValue = cellValue.replace(/,/g, '');
              if (!isNaN(numericValue) && numericValue !== '') {
                cellValue = { t: 'n', v: parseFloat(numericValue) }; // ✅ number
              } else {
                cellValue = { t: 's', v: cellValue }; // default text
              }
            }

            // Handle colspan by repeating value for each spanned column
            for (let i = 0; i < colspan; i++) {
              rowData.push(cellValue);
            }

            // Adjust column widths dynamically
            const displayValue = typeof cellValue.v !== 'undefined' ? cellValue.v.toString() : '';
            if (rowIndex === 0 && colIndex >= colWidths.length) {
              colWidths.push({ wch: displayValue.length + 5 });
            } else if (colWidths[colIndex] && colWidths[colIndex].wch < displayValue.length + 5) {
              colWidths[colIndex].wch = displayValue.length + 5;
            }

            // Handle merges for colspan
            if (colspan > 1) {
              merges.push({
                s: { r: allRows.length, c: lastColIndex },
                e: { r: allRows.length, c: lastColIndex + colspan - 1 }
              });
            }

            lastColIndex += colspan;
          });

          allRows.push(rowData);
        });

        // Add an empty row between tables
        if (tableIndex < tables.length - 1) {
          allRows.push([]);
        }

        // Handle table footer if exists
        const footer = table.querySelector('tfoot');
        if (footer) {
          const footerRows = footer.querySelectorAll('tr');
          footerRows.forEach((footerRow) => {
            const cells = footerRow.querySelectorAll('td');
            const footerRowData = [];
            let lastColIndex = 0;

            cells.forEach((cell) => {
              let cellValue = cell.innerText.trim();
              const colspan = parseInt(cell.getAttribute('colspan')) || 1;

              // Type detection again
              const numericValue = cellValue.replace(/,/g, '');
              if (isDateTime(cellValue)) {
                cellValue = { t: 's', v: cellValue };
              } else if (!isNaN(numericValue) && numericValue !== '') {
                cellValue = { t: 'n', v: parseFloat(numericValue) };
              } else {
                cellValue = { t: 's', v: cellValue };
              }

              for (let i = 0; i < colspan; i++) {
                footerRowData.push(cellValue);
              }

              // Merge footer cells if colspan
              if (colspan > 1) {
                merges.push({
                  s: { r: allRows.length, c: lastColIndex },
                  e: { r: allRows.length, c: lastColIndex + colspan - 1 }
                });
              }

              lastColIndex += colspan;
            });

            allRows.push(footerRowData);
          });
        }
      });

      // Convert all rows into worksheet
      const ws = XLSX.utils.aoa_to_sheet(allRows.map(row =>
        row.map(cell => (typeof cell === 'object' && cell.v !== undefined ? cell.v : cell))
      ));

      // Apply cell types after sheet creation
      allRows.forEach((row, rIdx) => {
        row.forEach((cell, cIdx) => {
          if (typeof cell === 'object' && cell.t && cell.v !== undefined) {
            const cellRef = XLSX.utils.encode_cell({ r: rIdx, c: cIdx });
            ws[cellRef] = { t: cell.t, v: cell.v };
          }
        });
      });

      // Apply column widths and merges
      ws['!cols'] = colWidths;
      if (merges.length > 0) ws['!merges'] = merges;

      // Append sheet to workbook
      XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

      // Generate filename
      const worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + 
                            this.$moment(this.date.endDate).format("YYYYMMDD");
      const filename = `${this.mode}-${this.$store.getters.accountId.toUpperCase()}-${worksheetTitle}.xlsx`;

      // Export Excel file
      XLSX.writeFile(workbook, filename);
      this.loading = false;
    },
    tableToExcelBonusLog() {
      const keySequence = ['member_id', 'bonus_name', 'bonus_desc', 'bonus_type', 'bonus_value', 'created_by', 'created_date'];
      const columnKeys = ['member_id', 'bonus_name', 'bonus_desc', 'bonus_type', 'bonus_value', 'created_by', 'created_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelAdjustmentLog() {
      const keySequence = ['member_id', 'balance_before', 'amount', 'balance_after', 'remark', 'created_by', 'created_date'];
      const columnKeys = ['member_id', 'balance_before', 'amount', 'balance_after', 'remark', 'created_by', 'created_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelOneTimeDepositor() {
      const keySequence = ['account_id', 'parent_id', 'contact_phone', 'ticket_date'];
      const columnKeys = ['account_id', 'operator_id', 'contact_phone', 'ticket_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelCurrentMonthNonDepositor() {
      const keySequence = ['parent_id','account_id', 'contact_phone', 'full_name', 'ltd_date'];
      const columnKeys = ['operator_id','account_id', 'contact_phone', 'full_name', 'ltd_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelCurrentMonthNoLogin() {
      const keySequence = ['parent_id', 'account_id', 'login_date'];
      const columnKeys = ['operator_id', 'account_id', 'login_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelDepositedMember() {
      const keySequence = ['parent_id','account_id', 'contact_phone', 'full_name'];
      const columnKeys = ['operator_id','account_id', 'contact_phone', 'full_name'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelRegisteredMember() {
      const keySequence = ['parent_id', 'account_id', 'contact_phone', 'referrer_id', 'affiliate_id', 'verified_date'];
      const columnKeys = ['operator_id', 'account_id', 'contact_phone', 'upline', 'affiliate', 'verified_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelFirstDeposit() {
      const keySequence = ['parent_id','account_id', 'ftd_amount', 'ftd_date', 'contact_phone', 'full_name', 'promotion_id', 'promotion_name', 'fl_provider_code', 'fl_game_id', 'fl_game_name'];
      const columnKeys = ['operator_id','account_id', 'ftd_amount', 'ftd_date', 'contact_phone', 'full_name', 'promo_id', 'promo_name', 'fl_provider_code', 'fl_game_id', 'fl_game_name'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelRebateListMember() {
      // Define the desired sequence of keys
      const keySequence = ['working_date', 'account_id', 'inbox_id', 'vip', 'rebate_mode', 'rebate_rate', 'rebate_type',  'turnover', 'turnover_tier', 'actual_rebate', 'rounded_rebate', 'action_date'];
      const columnKeys = ['working_date', 'account_id', 'inbox_id', 'vip', 'rebate_mode', 'rebate_rate', 'rebate_type',  'turnover', 'turnover_tier', 'actual_rebate', 'rounded_rebate', 'action_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelLoginLog() {
      const keySequence = ['action_by', 'contact_phone', 'action_type', 'login_ip', 'browser_agent', 'action_date'];
      const columnKeys = ['account_id', 'contact_phone', 'action_status', 'login_ip', 'browser_agent', 'action_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelGameNameExcludeLog() {
      const keySequence = ['provider_code', 'game_name', 'action_type', 'action_by', 'action_date'];
      const columnKeys = ['provider_code', 'game_name', 'action_status', 'action_by', 'action_date'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelDailyLedgerOperator() {
      const keySequence = ['account_id', 'turnover', 'valid_turnover', 'deposit_amount', 'deposit_count', 'withdrawal_amount', 'withdrawal_count', 'd_w_diff', 'winlose',
                           'bonus_amount', 'ngr', 'adjustment_amount', 'verified_count', 'active_member', 'referee_count', 'signup_count', 'ftd_count', 'ftd_amount',
                           'unique_login_count', 'unique_withdrawal_count', 'second_deposit_count'];
      const columnKeys = ['account_id', 'turnover', 'valid_turnover', 'deposit_amount', 'deposit_count', 'withdrawal_amount', 'withdrawal_count', 'deposit_withdrawal_different', 'winlose',
                          'bonus_amount', 'ngr', 'adjustment_amount', 'verified_count', 'active_member', 'referee_count', 'signup_count', 'ftd_count', 'ftd_amount',
                          'unique_login_count', 'unique_withdrawal_count', 'second_deposit_count'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelDailyLedgerMember() {
      const keySequence = ['account_id', 'turnover', 'valid_turnover', 'winlose', 'deposit_amount', 'deposit_count', 'withdrawal_amount', 'withdrawal_count',
                          'bonus_amount', 'adjustment_amount', 'referee_count'];
      const columnKeys = ['account_id', 'turnover', 'valid_turnover', 'winlose', 'deposit_amount', 'deposit_count', 'withdrawal_amount', 'withdrawal_count',
                          'bonus_amount', 'adjustment_amount', 'referee_count'];
      this.reformatExcelExport(keySequence, columnKeys);
    },
    tableToExcelFreeSpinLog() {
      const keySequence = ['member_id', 'free_round_id', 'provider_code', 'game_code', 'bet_value', 'line_bet', 'total_round', 'max_win_amount', 
                            'expiry_interval', 'action_type', 'remark', 'action_by', 'action_date'];
      const columnKeys = ['member_id', 'round_id', 'provider_code', 'game_code', 'bet_value', 'line_bet', 'total_round', 'max_win_amount', 
                            'expiry_interval_days', 'action', 'remark', 'action_by', 'action_date'];
      this.reformatExcelExportWithDate(keySequence, columnKeys);
    },
    tableToExcelAdjustFreeBalanceLog() {
      const keySequence = ['account_id', 'balance_before', 'amount', 'balance_after', 'action_type', 'remark', 'action_by', 'action_date'];
      const columnKeys = ['account_id', 'balance_before', 'amount', 'balance_after', 'action_status', 'remark', 'action_by', 'action_date'];
      this.reformatExcelExportWithDate(keySequence, columnKeys);
    },
    reformatExcelExport(keySequence, columnKeys) {
      var jsonData = this.dttbl;
      var worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD")
      this.loading = true;

      // Filter out "totalrows" key
      const filteredData = jsonData.map(({ totalrows, ...rest }) => rest);

      // Function to resequence an object's keys based on the specified sequence
      function resequenceObjectKeys(obj, _this) {
        const indexLabels = {}

        // Iterate over the array `keySequence` and populate `indexLabels` with keys starting from 1
        columnKeys.forEach((item, index) => {
          indexLabels[index + 1] = _this.$t(`ui.${item}`).trim().toUpperCase();
        });

        const newObj = {};
        keySequence.forEach((key, index) => {
          newObj[indexLabels[index + 1]] = obj[key] == null ? '' : obj[key];
        });
        return newObj;
      }

      // Apply the resequencing to each object in the filtered data
      const resequencedData = filteredData.map(obj => resequenceObjectKeys(obj, this));

      // Convert resequenced data to array of arrays (for Excel)
      const excelData = resequencedData.map(obj => Object.values(obj));

      // Convert data to worksheet
      const ws = XLSX.utils.aoa_to_sheet([Object.keys(resequencedData[0]), ...excelData]);

      // Initialize column widths with minimum width
      const minColumnWidth = 20; // Set a minimum width to ensure columns are visible
      const columnWidths = Array(excelData[0].length).fill(minColumnWidth);

      // Adjust column widths based on content length and header label length
      excelData.forEach(row => {
        row.forEach((cell, colIndex) => {
          const cellLength = (cell + '').length; // Calculate the length of the cell content
          const headerLabelLength = (ws[XLSX.utils.encode_cell({ r: 1, c: colIndex })].v + '').length; // Calculate the length of the header label
          const newWidth = Math.max(cellLength * 1.2, headerLabelLength * 1.2); // Choose the maximum width
          columnWidths[colIndex] = Math.max(columnWidths[colIndex], newWidth); // Set the width for the column
        });
      });

      ws['!cols'] = columnWidths.map(width => ({ width }));

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, worksheetTitle);

      // Save the workbook as an Excel file
      XLSX.writeFile(wb, this.mode + "-" + this.$store.getters.accountId.toUpperCase() + "-" +  worksheetTitle +  ".xlsx");

      this.loading = false;
    },
    reformatExcelExportWithDate(keySequence, columnKeys) {
      var jsonData = this.dttbl;
      var worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD")
      this.loading = true;

      // Filter out "totalrows" key
      const filteredData = jsonData.map(({ totalrows, ...rest }) => rest);

      // Function to resequence an object's keys based on the specified sequence
      function resequenceObjectKeys(obj, _this) {
        const indexLabels = {}

        // Iterate over the array `keySequence` and populate `indexLabels` with keys starting from 1
        columnKeys.forEach((item, index) => {
          indexLabels[index + 1] = _this.$t(`ui.${item}`).trim().toUpperCase();
        });

        const newObj = {};
        keySequence.forEach((key, index) => {
          if(key == 'action_date') {
            newObj[indexLabels[index + 1]] = obj[key] == null ? '' : _this.$moment(obj[key]).format('YYYY-MM-DD, HH:mm:ss');
          }
          else
            newObj[indexLabels[index + 1]] = obj[key] == null ? '' : obj[key];
        });
        return newObj;
      }

      // Apply the resequencing to each object in the filtered data
      const resequencedData = filteredData.map(obj => resequenceObjectKeys(obj, this));

      // Convert resequenced data to array of arrays (for Excel)
      const excelData = resequencedData.map(obj => Object.values(obj));

      // Convert data to worksheet
      const ws = XLSX.utils.aoa_to_sheet([Object.keys(resequencedData[0]), ...excelData]);

      // Initialize column widths with minimum width
      const minColumnWidth = 20; // Set a minimum width to ensure columns are visible
      const columnWidths = Array(excelData[0].length).fill(minColumnWidth);

      // Adjust column widths based on content length and header label length
      excelData.forEach(row => {
        row.forEach((cell, colIndex) => {
          const cellLength = (cell + '').length; // Calculate the length of the cell content
          const headerLabelLength = (ws[XLSX.utils.encode_cell({ r: 1, c: colIndex })].v + '').length; // Calculate the length of the header label
          const newWidth = Math.max(cellLength * 1.2, headerLabelLength * 1.2); // Choose the maximum width
          columnWidths[colIndex] = Math.max(columnWidths[colIndex], newWidth); // Set the width for the column
        });
      });

      ws['!cols'] = columnWidths.map(width => ({ width }));

      // Create a new workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, worksheetTitle);

      // Save the workbook as an Excel file
      XLSX.writeFile(wb, this.mode + "-" + this.$store.getters.accountId.toUpperCase() + "-" +  worksheetTitle +  ".xlsx");

      this.loading = false;
    },
  }
};
</script>
